export default __webpack_public_path__ + "static/media/shahzadi._compressed.4d7c7cf0.png";